import { Button, InnoTable } from "InnoUI/components";
import SC from "./style";
import theme from "@theme/";
import CustomAccordion from "InnoUI/components/CustomAccordion";
import { useNavigate, useSearchParams } from "react-router-dom";
import TimezoneConverter from "components/TimeZoneConvertor";

const OutstandingIssue = (props) => {
  const { occupantData = { outstandingData: [] } } = props;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const navigate = useNavigate();

  const viewThread = (record) => {
    navigate(
      `/journal/open-thread?projectId=${occupantData.id}&type=${type}&journalId=${record.journalId}`
    );
  };

  const subColumnData = [
    {
      title: "Date",
      dataIndex: "createdOn",
      width: 650,
      onCell: () => ({}),
      render(value, record) {
        return (
          <span
            style={{ color: theme.colors.modernGray[600], fontWeight: 500 }}
          >
            <TimezoneConverter time={value} />
          </span>
        );
      },
    },
    {
      title: "Subject",
      dataIndex: "subject",
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <span
              style={{ color: theme.colors.modernGray[700], fontWeight: 500 }}
            >
              {value}
            </span>
          </>
        );
      },
    },
    {
      title: "",
      dataIndex: "erer",
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <Button
              caption={"View thread"}
              onClick={() => viewThread(record)}
              color="white"
              fontSize="12px"
              style={{
                background: theme.gradient.modernPrimary,
                color: theme.colors.white,
                minWidth: "80px",
                height: "32px",
                borderRadius: theme.modernTokens.borderRadius.md,
                textTransform: "normal",
                fontWeight: 600,
                border: "none",
                boxShadow: theme.modernTokens.shadows.sm,
                transition: theme.modernTokens.transitions.normal,
              }}
            />
          </>
        );
      },
    },
  ];
  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: false,
    pagination: false,
    addNew: false,
    search: false,
    action: false,
    divBorder: false,
  };

  const totalJournals = occupantData?.outstandingData?.reduce((total, item) => {
    return total + (item.journals ? item.journals.length : 0);
  }, 0);

  return (
    <div style={{ marginBottom: "24px" }}>
      <SC.HeaderContainer>
        <SC.HeaderStyle>Outstanding issues</SC.HeaderStyle>
        <SC.CountStyle>{totalJournals || 0}</SC.CountStyle>
      </SC.HeaderContainer>
      <SC.CardContainerStyle>
        {occupantData?.outstandingData?.map((item, index) => (
          <CustomAccordion
            key={index}
            defaultExpanded={false}
            toggleIconsx={{ color: theme.colors.modernPrimary }}
            headerContent={
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "70%",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: theme.colors.modernGray[800],
                    margin: 0,
                  }}
                >
                  {item.role} - Total Issues: {item.journals.length}
                </p>
              </div>
            }
          >
            <div style={{ marginBottom: "16px" }}>
              <InnoTable
                tableConfig={tableConfig}
                padding={"12px"}
                column={subColumnData}
                data={item.journals}
              />
            </div>
          </CustomAccordion>
        ))}
      </SC.CardContainerStyle>
    </div>
  );
};

export default OutstandingIssue;
